module.exports = __webpack_public_path__ + "img/campaign-pilot-fox-w-back.8c5e191f.png";